<template>
    <div class="card">          
        <b-overlay :show="showoverlaymodal" rounded="sm" class="card-body">
            <b-form @submit.stop.prevent="onSubmit">
                <input type="hidden" v-model="fdata.id" name="id">

                <b-form-group id="name-group" class="half-width mr1" label="Agent Name" label-for="name">
                    <b-form-input id="name" name="name" v-model="fdata.name" v-validate="{ required: true, min: 3 }" :state="validateState('name')" aria-describedby="name-feedback" data-vv-as="Agent Name"></b-form-input>
                    <b-form-invalid-feedback id="name-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="admin_id-group" class="half-width" label="Assigned Admin User" label-for="admin_id" >
                    <b-form-select id="admin_id" name="admin_id" v-model="fdata.admin_id" v-validate="{ required: true }" :options="admin_ids" :state="validateState('admin_id')" aria-describedby="status-feedback" data-vv-as="Assigned Admin User"></b-form-select>
                    <b-form-invalid-feedback id="admin_id-feedback">{{ veeErrors.first('admin_id') }}</b-form-invalid-feedback>
                </b-form-group>
               

                <div id="company_logo-group"  role="group" class="form-group half-width mr1">
                    <label id="company_logo-group__BV_label_" for="company_logo" class="d-block">Logo</label>
                    <div class="bv-no-focus-ring cmpny-logo-uploader">                           
                        <my-upload field="img"
                            @crop-success="cropSuccess"
                            v-model="showLogoUploader"
                            lang-type="en"
                            :width="400"
                            :height="400"
                            img-format="jpeg"></my-upload>

                        <img :src="logoUrl"  @click="toggleLogoUploader" style="cursor: pointer;">
                        <div @click="toggleLogoUploader" class="cmpny-logo-overlay">Upload</div>
                    </div>
                </div>

                <b-form-group class="reuired half-width" id="address-group" label="Address" label-for="address">
                    <b-form-textarea id="address" name="address" v-model="fdata.address" v-validate="{ required: true, min: 3 }" :state="validateState('address')" aria-describedby="address-feedback" data-vv-as="Address"></b-form-textarea>
                    <b-form-invalid-feedback id="address-feedback">{{ veeErrors.first('address') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="etin-group" class="half-width mr1" label="eTin" label-for="etin">
                    <b-form-input id="etin" name="etin" v-model="fdata.etin" v-validate="{  min: 12 , max: 12 }" :state="validateState('etin')" aria-describedby="etin-feedback" data-vv-as="eTin"></b-form-input>
                    <b-form-invalid-feedback id="etin-feedback">{{ veeErrors.first('etin') }}</b-form-invalid-feedback>
                </b-form-group>

                <b-form-group id="bin-group" class="half-width" label="BIN" label-for="bin">
                    <b-form-input id="bin" name="bin" v-model="fdata.bin" v-validate="{   }" :state="validateState('bin')" aria-describedby="bin-feedback" data-vv-as="BIN"></b-form-input>
                    <b-form-invalid-feedback id="bin-feedback">{{ veeErrors.first('bin') }}</b-form-invalid-feedback>
                </b-form-group>

                <!--<b-form-group class="reuired half-width mr1" id="contact_details-group" label="Contact Details" label-for="contact_details">
                    <b-form-textarea id="contact_details" name="contact_details" v-model="fdata.contact_details" v-validate="{ required: true, min: 3 }" :state="validateState('contact_details')" aria-describedby="contact_details-feedback" data-vv-as="Contact Details"></b-form-textarea>
                    <b-form-invalid-feedback id="contact_details-feedback">{{ veeErrors.first('contact_details') }}</b-form-invalid-feedback>
                </b-form-group>-->

                <b-form-group id="status-group" class="half-width" label="Status" label-for="status">
                    <b-form-select id="status" name="status" v-model="fdata.status" v-validate="{ required: true }" :options="status" :state="validateState('status')" aria-describedby="status-feedback" data-vv-as="Status"></b-form-select>
                    <b-form-invalid-feedback id="status-feedback">{{ veeErrors.first('status') }}</b-form-invalid-feedback>
                </b-form-group>
                <div class="full-width">
                <b-button type="submit" variant="success">Submit</b-button>  
                </div>              
            </b-form> 
        </b-overlay>
    </div>
</template>
<script>
    import myUpload from 'vue-image-crop-upload';
    export default{
        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
            
        },
        components: {'my-upload': myUpload, },
        data(){            
            
            return {
                cu : window.location.href,
                ce : false, 
                         
                successmsg : '',
                errormsg : [],
                blankmsg : 'Fetching data..',
                fdata : {status:null , id:null, email:null, phone:null, admin_id:null , address:'' , etin:'' , bin:'' , contact_details:''},
    
                file : null,
                
                showoverlay : false,
                showoverlaymodal : false,

                status: [
                    { value: null, text: "Select..." },
                    { value: "1", text: "Active" },
                    { value: "2", text: "Pending" },
                    { value: "3", text: "Not Approved" },
                    { value: "4", text: "Other" },
                ],
                
                logoUrl : null,
                logoUploaded: false,
                showLogoUploader: false,
                
            }
        },
        methods:{
            toggleLogoUploader() {
				this.showLogoUploader = !this.showLogoUploader;
			},
            cropSuccess(imgDataUrl, field){
				
				this.logoUrl = imgDataUrl;
                this.logoUploaded = true;
			},
            editAgent:function()
            { 
                if(!this.checkNet()) return false;
                let currentObj = this;

                this.newagent = false;        
                this.errormsg = [];
                this.successmsg = '';
                
                axios.get(this.$api_url+'/agent/details' , {
                    params: {
                        
                    }
                }).then(function(response){
                    this.fdata.id = response.data.id;
                    this.fdata.name = response.data.name;
                    this.fdata.admin_id = response.data.admin_id;
                    this.fdata.status = response.data.status;

                    this.fdata.address = response.data.address;
                    this.fdata.etin = response.data.etin;
                    this.fdata.bin = response.data.bin;
                    this.fdata.contact_details = response.data.contact_details;

                    this.admin_ids = response.data.admin_ids;
                    this.logoUrl = this.$api_url + '/images/agent/' + response.data.logo;
                    this.file = null;
                    this.$validator.reset();
                }.bind(this))
                .catch(function (error)
                {
                    currentObj.serverError(error);
                });

                this.$bvModal.show('bv-modal-example');
                
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlaymodal = true;
                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();
                    
                    
                    if(this.logoUploaded)
                        formData.append('logo', this.logoUrl);
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);                    
                        //console.log(`${key}: ${value}`);
                    } 

                    axios.post(this.$api_url+'/agent/save', formData, config)
                                .then(function (response) 
                                {   
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        }); 

                                    
                                    setTimeout("location.href = '"+this.$api_url+"';",1500);
                                    
                                    this.$bvModal.hide('bv-modal-example');
                                    this.showoverlaymodal = false;                                    
                                    this.resetForm();
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {                                    
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;                                    
                                    for (var data in currentObj.errormsg)
                                    {
                                        var msg = currentObj.errormsg[data];
                                        currentObj.$bvToast.toast(msg, {
                                            title: `Error`,
                                            variant: 'danger',
                                            solid: true
                                        }); 
                                        currentObj.$validator.reset();
                                    }
                                });
                });
            },

        },
        created: function(){
           
            this.editAgent();
            
        },
    }
</script>
